export default __webpack_public_path__ + "static/media/Case_Titanium.899e821e.png";